/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

function DetallesCandidato({ candidato }) {
  // Formatear fecha de creación
  const formatearFecha = (fechaISO) => {
    if (!fechaISO) return "No especificado";
    try {
      const fecha = new Date(fechaISO);
      return fecha.toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    } catch (error) {
      return fechaISO;
    }
  };

  const detalles = [
    { label: "Nombre Completo", value: candidato.nombre_completo },
    { label: "Documento", value: candidato.documento },
    { label: "Email", value: candidato.email },
    { label: "Fecha de Nacimiento", value: candidato.fecha_nacimiento },
    { label: "Edad", value: candidato.edad },
    { label: "Género", value: candidato.genero },
    { label: "Dirección", value: candidato.direccion },
    { label: "Nivel Educativo", value: candidato.nivel_educativo },
    { label: "Experiencia Laboral", value: candidato.experiencia_laboral },
    { label: "Habilidades Destacadas", value: Array.isArray(candidato.habilidades_destacadas) ? candidato.habilidades_destacadas.join(", ") : candidato.habilidades_destacadas },
    { label: "Motivación para el Cargo", value: candidato.motivacion_cargo },
    { label: "Cargo Aplicado", value: candidato.cargo_aplicado },
    { label: "Ubicación Geográfica", value: candidato.ciudad },
    { label: "País", value: candidato.pais },
    { label: "Emociones", value: candidato.emociones },
    { label: "Fecha de Creación", value: formatearFecha(candidato.created_at) },
  ];

  return (
    <MDBox p={3}>
      <Grid container spacing={2}>
        {detalles.map((detalle, index) => (
          <Grid item xs={12} sm={6} key={index}>
            <MDBox mb={2}>
              <MDTypography variant="caption" color="text" fontWeight="bold" textTransform="uppercase">
                {detalle.label}
              </MDTypography>
              <MDTypography variant="body2" fontWeight="regular">
                {detalle.value || "No especificado"}
              </MDTypography>
            </MDBox>
          </Grid>
        ))}
      </Grid>
    </MDBox>
  );
}

// Typechecking props for the DetallesCandidato
DetallesCandidato.propTypes = {
  candidato: PropTypes.shape({
    nombre_completo: PropTypes.string,
    documento: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    email: PropTypes.string,
    fecha_nacimiento: PropTypes.string,
    edad: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    genero: PropTypes.string,
    direccion: PropTypes.string,
    nivel_educativo: PropTypes.string,
    experiencia_laboral: PropTypes.string,
    habilidades_destacadas: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    motivacion_cargo: PropTypes.string,
    cargo_aplicado: PropTypes.string,
    ciudad: PropTypes.string,
    pais: PropTypes.string,
    emociones: PropTypes.string,
    created_at: PropTypes.string,
  }).isRequired,
};

export default DetallesCandidato;